export default from './Footer'


// WEBPACK FOOTER //
// ./src/components/Footer/index.js